import { NAV_SECTIONS } from '@/lib/nav';

/**
 * The title and one-line subtitle in the top bar, resolved from the path.
 *
 * Derived from NAV_SECTIONS rather than kept as a second list, so a nav item and its
 * page heading cannot drift apart - and a new destination gets a real heading for
 * free instead of falling back to a bare path.
 */
const EXTRA: Record<string, { title: string; subtitle: string }> = {
  '/login': { title: 'Sign in', subtitle: 'CargoFL Asset Tracker' },
  '/assets/new': { title: 'Register asset', subtitle: 'Add a new asset to the register' },
};

export function pageMeta(pathname: string): { title: string; subtitle: string | null } {
  const extra = EXTRA[pathname];
  if (extra) return extra;

  // Longest match wins, so /assets/<id> keeps the Assets heading rather than falling
  // through to the default.
  let best: { title: string; subtitle: string } | null = null;
  let bestLength = -1;
  for (const section of NAV_SECTIONS) {
    for (const item of section.items) {
      if (
        (pathname === item.href || pathname.startsWith(`${item.href}/`)) &&
        item.href.length > bestLength
      ) {
        best = { title: item.title, subtitle: item.description };
        bestLength = item.href.length;
      }
    }
  }

  return best ?? { title: 'CargoFL Asset Tracker', subtitle: null };
}
